import { computed } from 'vue'
import { useLocaleStore } from '@/stores/locale'

export function useFormatPrice () {
  const localeStore = useLocaleStore()
  const locale = computed(() => localeStore.currentLocale)

  return (price, forceLocale) => {
    if (typeof price !== 'number') return ''

    const localeToUse = forceLocale?.locale || locale.value.locale
    const currencyToUse = forceLocale?.currency || locale.value.currency

    return new Intl.NumberFormat(localeToUse.replace('_', '-'), {
      style: 'currency',
      currency: currencyToUse,
    }).format(price / 100)
  }
}
